import {
    RECEIVE_ASSESSMENT
} from '../../actions/appActions';

const initialState = {
    hideHeader: true,
    hideFooter: true,
    linkoutResults: false,
    whisper: 'HEALTHLINE ASSESSMENT'
};

const ConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case RECEIVE_ASSESSMENT:
            if (action.assessment.inlineConfig) {
                return action.assessment.inlineConfig;
            }

            return state;

        default:
            return state;
    }
};

export default ConfigReducer;